<template>
  <div class="projektDetailansicht">
    <FormModule
      :formIdentifier="formIdentifier"
      @close="closeForm()"
      :saveable="false"
      :editable="false"
    >
      <template v-slot:header>
        <h2>Projektansicht</h2>
      </template>
      <template v-slot:content>
        <b-unit no-header>
          <div class="scrollArea">
            <ProjektStammdaten :projektleiter="projektleiter" />
            <Projektleiter />
            <Technologieberater />
            <b-row>
              <b-column style="text-align: right; margin-right: 35px">
                <b-btn :disabled="!formIsDirty" @click="datenSpeichern()"
                  >Speichern</b-btn
                >
              </b-column>
            </b-row>
          </div>
        </b-unit>
      </template>
    </FormModule>

    <v-container>
      <b-row>
        <b-column>
          <b-radio
            label="Wurde die Verwertung bereits abgeschlossen oder dauert diese noch an?"
            v-model="verwertungAbgeschlossen"
            true-label="Verwertung wurde abgeschlossen"
            false-label="Verwertung dauert noch an"
          />
        </b-column>
      </b-row>
      <b-row>
        <b-column cols="4">
          <h3>Zugehöriger Fragebogen</h3>
        </b-column>
        <b-column cols="4">
          <h3>Wiedervorlage</h3>
        </b-column>
      </b-row>
      <b-row>
        <!-- Fragebogen -->
        <b-column v-if="fragebogen_id" cols="4">
          <b-row>
            <p class="pt-3 mb-0">Fragebogen: {{ fragebogen_id }}</p>
          </b-row>
          <b-row>
            <p class="mb-0">Status: {{ fragebogen_versandt ? 'offen' : 'kein offener Fragebogen' }}</p>
          </b-row>
          <b-row v-if="fragebogen_versandt">
            <p class="mb-0">Versandt: {{ fragebogen_versandt ? getformattedDate(fragebogen_versandt) : '-' }}</p>
          </b-row>
          <b-row  v-if="fragebogen_gueltig_bis">
            <p>Gueltig bis: {{ fragebogen_gueltig_bis ? getformattedDate(fragebogen_gueltig_bis) : '-' }}</p>
          </b-row>
          <b-row>
            <b-btn @click="fragebogenVorschau()"> Vorschau anzeigen </b-btn>
          </b-row>

          <template v-for="(item, key) in zwischenstaendeListe">
            <b-row :key="key">
              <p class="pt-3">
                Beantwortet am :
                {{ item.datumLesbar }}
              </p>
            </b-row>
            <b-row :key="key">
              <b-btn @click="fragebogenZwischenstandUebersicht(item)">
                Zwischenstand anzeigen</b-btn
              >
            </b-row>
          </template>
        </b-column>
        <b-column v-else cols="4">
          <b-row>
            <b-column>
              <b-btn @click="erstelleFragebogen()">Fragebogen Erstellen</b-btn>
            </b-column>
          </b-row>
          <b-row>
            <b-column>
              <p>Noch keine Antworten vorhanden.</p>
            </b-column>
          </b-row>
        </b-column>

        <!-- Wiedervorlage -->
        <div v-if="fragebogen_id">
          <b-column cols="8" v-if="fragebogen_wiedervorlagen">
            <b-row>
              <p class="pt-3">
                Wiedervorlage:
                {{
                  fragebogen_wiedervorlagen.datum
                    ? getformattedDate(fragebogen_wiedervorlagen.datum)
                    : ''
                }}
              </p>
            </b-row>
            <b-row>
              <b-btn @click="oeffnePopupWiedervorlage()">
                Wiedervorlage bearbeiten
              </b-btn>
            </b-row>
          </b-column>
          <b-column cols="4" v-else>
            <b-row>
              <b-column>
                <b-btn @click="oeffnePopupWiedervorlage()"
                  >Wiedervorlage erstellen</b-btn
                >
              </b-column>
            </b-row>
            <b-row>
              <b-column>
                <p>Noch keine Wiedervorlage erstellt.</p>
              </b-column>
            </b-row>
          </b-column>
        </div>
        <div v-else>
          <b-column cols="8">
            <b-row>
              <b-column>
                <p>Es wurde noch kein Fragebogen erstellt</p>
              </b-column>
            </b-row>
          </b-column>
        </div>
      </b-row>
    </v-container>
    <WiedervorlagePopup
      v-if="zeigeWiedervorlagePopup"
      :projektId="uuid"
      :wiedervorlage="fragebogen_wiedervorlagen"
      @close="zeigeWiedervorlagePopup = false"
      @save="wiedervorlageErstellt"
    />
    <v-snackbar v-model="showSnackbar" timeout="4000" :color="snackbarColor">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import dataMixin from '@/mixins/data-mixin';
import FormModule from '@/components/base_components/FormModule';
import { mapGetters, mapMutations } from 'vuex';
import axios from 'axios';
import Projektleiter from '@/views/projekt/Projektleiter';
import Technologieberater from '@/views/projekt/Technologieberater';
import ProjektStammdaten from '@/views/projekt/ProjektStammdaten';
import dateFormatService from '../../service/date-format-service';
import dirtyCheckMixin from '@/mixins/dirty-check-mixin';
import WiedervorlagePopup from '@/components/popups/WiedervorlagePopup';

export default {
  name: 'ProjektDetailansicht',
  components: {
    ProjektStammdaten,
    FormModule,
    Projektleiter,
    Technologieberater,
    WiedervorlagePopup,
  },
  props: {
    uuid: [String],
  },
  data() {
    return {
      formIdentifier: { type: 'projekt/detail', uuid: this.uuid },
      hint: 'Pflichtfeld',
      rules: {
        required: (value) => !!value || this.hint,
      },
      showSnackbar: false,
      saveSuccess: false,
      snackbarText: '',
      zeigeWiedervorlagePopup: false,
    };
  },
  mixins: [
    dirtyCheckMixin(),
    dataMixin('formIsDirty', 'transientData.formIsDirty'),

    dataMixin('persistentData', 'persistentData', {}),
    //Fragebögen
    dataMixin('fragebogen_id', 'persistentData.fragebogenID'),
    dataMixin('fragebogen_versandt', 'persistentData.versandt'),
    dataMixin('fragebogen_gueltig_bis', 'persistentData.gueltigBis'),
    dataMixin('fragebogen_antworten', 'persistentData.antworten'),
    dataMixin('fragebogen_wiedervorlagen', 'persistentData.wiedervorlage'),

    dataMixin('verwertungAbgeschlossen', 'persistentData.projekt.verwertungAbgeschlossen'),
  ],
  computed: {
    ...mapGetters('userData', ['getUserData']),
    projektleiter: function () {
      let projektleiter = '';
      if (
        this.persistentData.projekt == undefined ||
        this.persistentData.projekt.projektLeiter.vorname == undefined ||
        this.persistentData.projekt.projektLeiter.nachname == undefined
      )
        projektleiter = ' ';
      else if (this.persistentData.projekt.projektLeiter.titel == undefined) {
        projektleiter =
          this.persistentData.projekt.projektLeiter.vorname +
          ' ' +
          this.persistentData.projekt.projektLeiter.nachname;
      } else {
        projektleiter =
          this.persistentData.projekt.projektLeiter.titel +
          ' ' +
          this.persistentData.projekt.projektLeiter.vorname +
          ' ' +
          this.persistentData.projekt.projektLeiter.nachname;
      }
      return projektleiter;
    },
    zwischenstaendeListe: function () {
      let list = [];
      if (this.fragebogen_antworten != undefined) {
        list = this.fragebogen_antworten.map((item) => {
          return {
            position: item.position,
            datumLesbar: item.datum ? dateFormatService.formatDate(new Date(item.datum)) : '-',
            datumIso: item.datum,
          };
        });
      }
      list.shift();
      return list;
    },
    snackbarColor: function () {
      return this.saveSuccess ? `primary` : `red`;
    },
  },
  created() {
    this.resetFormData();
  },
  methods: {
    ...mapMutations('formData', ['resetFormData']),
    updateUserData() {
      axios.put(this.formIdentifier.type, this.getFormData.persistentData);
    },
    closeForm() {
      this.$router.push('/projekt');
    },
    projektdatenSpeichern() {
      return this.formIdentifier.uuid === undefined
        ? axios.post(`/v1/projekt`, this.getFormData.persistentData.projekt)
        : axios.put(
            `/v1/projekt/${this.formIdentifier.uuid}`,
            this.getFormData.persistentData.projekt
          );
    },

    fragebogenVorschau() {
      this.$router.push('/fragebogenVorschau/' + this.fragebogen_id);
    },
    fragebogenZwischenstandUebersicht(item) {
      this.$router.push(
        `/fragebogenZwischenstandUebersicht/uuid/${this.fragebogen_id}` +
          `/position/${item.position}` +
          `/aktuell/` +
          (item.datumIso == this.fragebogen_antworten[this.fragebogen_antworten.length - 1].datum)
      );
    },
    datenSpeichern() {
      this.projektdatenSpeichern().then(
        (response) => {
          if (200 <= response.statusCode < 300) {
            this.saveSuccess = true;
            this.showSnackbar = true;
            this.formIsDirty = false;
            this.snackbarText = 'Projekt wurde erfolgreich gespeichert';
          }
        },
        (err) => {
          err;
          this.saveSuccess = false;
          this.showSnackbar = true;
          this.snackbarText = 'Fehlern beim Speichern aufgetreten';
        }
      );
    },
    erstelleFragebogen() {
      const vorlage = {
        projektId: this.uuid,
        traegerschaft: this.getUserData.projekttraegerschaftName,
      };
      axios
        .post('/v1/fragebogen/create', vorlage)
        .then((response) => {
          this.saveSuccess = true;
          this.showSnackbar = true;
          this.snackbarText = 'Fragebogen wurde erfolgreich erstellt';
          this.fragebogen_id = response.data.id;
          this.$router.push('/fragebogenVorschau/' + this.fragebogen_id);
        })
        .catch((error) => {
          this.saveSuccess = false;
          this.showSnackbar = true;
          this.snackbarText = error.response.data;
        });
    },
    oeffnePopupWiedervorlage() {
      this.zeigeWiedervorlagePopup = true;
    },
    wiedervorlageErstellt() {
      this.saveSuccess = true;
      this.showSnackbar = true;
      location.reload();
      this.snackbarText = 'Wiedervorlage gespeichert';
    },
    getformattedDate(date) {
      if (date) {
        return dateFormatService.formatIsoDateString(date);
      } else {
        return '';
      }
    },
  },
};
</script>
<style scoped lang="scss">
.scrollArea {
  height: 485px;
  overflow-y: scroll;
  > div {
    width: 96%;
  }
}

.margin-top-small {
  margin-top: 10px;
}
.margin-top-big {
  margin-top: 25px;
}
</style>

